module.exports = __webpack_public_path__ + "static/media/gallery (2).fb6c1e1a.jpg";